
<template>
    <div
        class="g-recaptcha"
        data-size="invisible"
        data-callback="recaptchaCallback"
        :data-recaptcha-id="grecaptchaId"
        :data-sitekey="sitekey"></div>
</template>

<script>
    export default {
        props: {
            triggered: { default: undefined, type: Date },
            sitekey: { required: true, type: String },
            callback: { default: undefined, type: Function },
        },
        data() {
            return {
                recaptchaCallbackForm: null,
                grecaptchaIsLoaded: false,
                grecaptchaId: null,
                initGrecaptchaWaiterInterval: setInterval(this.initGrecaptchaWaiter, 250),
                customCallback: this.callback ? this.callback : (window.customRecaptchaCallback ? window.customRecaptchaCallback : null),
            };
        },
        watch: {
            triggered(value) {
                if (this.grecaptchaIsLoaded) {
                    window.grecaptcha.reset(this.grecaptchaId);
                }
                if (value) {
                    this.triggerRecaptcha();
                }
            },
            grecaptchaIsLoaded(status) {
                const _this = this; // eslint-disable-line @typescript-eslint/no-this-alias
                if (status === true) {
                    this.grecaptchaId = window.grecaptcha.render(_this.$el, {
                        'sitekey': _this.sitekey,
                    });
                    const textarea = document.getElementById('g-recaptcha-response');
                    textarea.setAttribute('aria-hidden', 'true');
                    textarea.setAttribute('aria-label', 'recaptcha response');
                    textarea.setAttribute('aria-readonly', 'true');
                }
            },
        },
        methods: {
            recaptchaCallback() {
                if (this.customCallback) {
                    this.customCallback();
                } else {
                    window.recaptchaCallbackForm.submit();
                }
            },
            triggerRecaptcha() {
                if (this.grecaptchaIsLoaded) {
                    if (window.grecaptcha.getResponse(this.grecaptchaId)) {
                        this.recaptchaCallback();
                    } else {
                        window.grecaptcha.execute(this.grecaptchaId).then(() => undefined);
                    }
                }
            },
            initGrecaptchaWaiter() {
                if (typeof window.grecaptcha === 'object' && typeof window.grecaptcha.render === 'function') {
                    this.grecaptchaIsLoaded = true;
                    clearInterval(this.initGrecaptchaWaiterInterval);
                }
            },
        },
        mounted() {
            this.recaptchaCallbackForm = this.$el.closest('form');
            window.recaptchaCallbackForm = this.recaptchaCallbackForm;
            window.recaptchaCallback = this.recaptchaCallback;
            this.$parent.$on('triggerRecaptcha', this.triggerRecaptcha);
        },
        created() {
            this.initGrecaptchaWaiter();
        },
    };
</script>
